// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
/*** Color Variables *****/
.mobile-signup {
  display: none;
}

.mobile-menu-icon {
  display: none;
}

.full-logo {
  width: auto;
  height: 60px;
  float: left;
  margin: 0px 18px 0px 0px;
  position: relative;
  display: flex;
  align-items: center;
}
.full-logo:before {
  content: none;
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 0px;
  left: 0px;
  background: #4cb8ac;
  opacity: 0;
}
.full-logo img {
  max-width: 100%;
  width: 109px;
  display: block;
  cursor: pointer;
}
.full-logo img:focus {
  outline: none;
  box-shadow: none;
}
.full-logo:focus {
  outline: none;
  box-shadow: none;
}
.full-logo .rev-Brand-img {
  display: block;
  cursor: pointer;
}
.full-logo .rev-Brand-img:focus {
  outline: none;
  box-shadow: none;
}
.full-logo .dark-Brand-img {
  display: none;
}
.full-logo .dark-Brand-img:focus {
  outline: none;
  box-shadow: none;
}

.header-top {
  background: none;
  position: fixed;
  width: 100%;
  z-index: 1000;
  top: 0;
  border-bottom: solid 1px rgba(255, 255, 255, 0.13);
  height: 61px;
  padding: 0px 20px 0px 20px;
  line-height: 61px;
  z-index: 1000;
}
.header-top .nav-top {
  background: none;
  line-height: 60px;
  border: none;
}
.header-top .nav-top li {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  border: none;
  vertical-align: middle;
  line-height: 60px;
  position: relative;
  top: auto;
  margin: 0;
  padding: 0;
}
.header-top .nav-top li:after {
  content: none;
}
.header-top .nav-top li:first-child a {
  padding: 0 19px 0 18px;
}
.header-top .nav-top li:nth-child(2) a {
  padding: 0 13.5px 0 18px;
}
.header-top .nav-top li a {
  display: block;
  line-height: 60px;
  position: relative;
  color: #fff;
  font-size: 14px;
  padding: 0 18.5px;
}
.header-top .nav-top li a:before {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 1px;
  left: 0px;
  background: #4cb8ac;
  opacity: 0;
  top: auto;
}
.header-top .nav-top li:hover {
  color: #ccc;
}
.header-top .nav-top li:hover:after {
  border-bottom: none;
}
.header-top .nav-top li:hover a:before {
  opacity: 1;
}
.header-top .nav-top li:focus {
  color: #ccc;
  outline: none;
  box-shadow: none;
}
.header-top .nav-top li:focus a:before {
  opacity: 1;
}
.header-top .nav-top li:active {
  color: #ccc;
  background: transparent;
}
.header-top .nav-top li:active a:before {
  opacity: 1;
}
.header-top .nav-top li.ant-menu-item.ant-menu-item-selected {
  background: transparent !important;
  color: #fff !important;
  outline: none;
  box-shadow: none;
  border-bottom-color: #fff;
}
.header-top .nav-top li.ant-menu-item.ant-menu-item-selected a:before {
  opacity: 1;
}
.header-top .nav-top li.ant-menu-item.ant-menu-item-selected:focus {
  background: transparent !important;
  color: #4cb8ac !important;
  outline: none;
  box-shadow: none;
}
.header-top .nav-top li.ant-menu-item.ant-menu-item-selected:focus a:before {
  opacity: 1;
}
.header-top .nav-top li.ant-menu-item.ant-menu-item-selected:active {
  background: transparent !important;
  color: #4cb8ac !important;
  outline: none;
  box-shadow: none;
}
.header-top .nav-top li.ant-menu-item.ant-menu-item-selected:active a:before {
  opacity: 1;
}
.header-top .nav-top-right {
  border: none;
  background: transparent;
  line-height: 60px;
  height: 60px;
  display: block;
}
.header-top .nav-top-right li {
  position: relative;
  vertical-align: middle;
  border: none;
  top: 0px;
  margin: 0 8.5px;
  padding: 0px;
  line-height: 60px;
}
.header-top .nav-top-right li a {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  display: block;
  line-height: 60px;
  position: relative;
  text-transform: none;
  letter-spacing: 0px;
  text-transform: uppercase;
}
.header-top .nav-top-right li a svg {
  line-height: 60px;
  display: block;
  fill: #4cb8ac;
  height: 60px;
}
.header-top .nav-top-right li a:before {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  bottom: 0px;
  left: 0px;
  background: #4cb8ac;
  opacity: 0;
  top: auto;
}
.header-top .nav-top-right li:hover {
  color: #ccc;
}
.header-top .nav-top-right li:hover:after {
  border-bottom: none;
}
.header-top .nav-top-right li:hover a:before {
  opacity: 1;
  background-color: transparent;
}
.header-top .nav-top-right li:hover a:hover:before {
  background-color: transparent;
}
.header-top .nav-top-right li:focus {
  color: #ccc;
  outline: none;
  box-shadow: none;
}
.header-top .nav-top-right li:focus a:before {
  opacity: 1;
  background-color: transparent;
}
.header-top .nav-top-right li:active {
  color: #ccc;
  background: transparent;
}
.header-top .nav-top-right li:active a:before {
  opacity: 1;
}
.header-top .nav-top-right li .ant-btn span {
  line-height: normal;
}
.header-top .nav-top-right li.notification {
  display: none;
}
.header-top .nav-top-right li.ant-menu-item.ant-menu-item-selected {
  background: transparent !important;
  color: #fff !important;
  outline: none;
  box-shadow: none;
  border-bottom-color: #fff;
}
.header-top .nav-top-right li.ant-menu-item.ant-menu-item-selected a:before {
  opacity: 1;
}
.header-top .nav-top-right li.ant-menu-item.ant-menu-item-selected:focus {
  background: transparent !important;
  color: #4cb8ac !important;
  outline: none;
  box-shadow: none;
}
.header-top .nav-top-right li.ant-menu-item.ant-menu-item-selected:focus a:before {
  opacity: 1;
}
.header-top .nav-top-right li.ant-menu-item.ant-menu-item-selected:active {
  background: transparent !important;
  color: #4cb8ac !important;
  outline: none;
  box-shadow: none;
}
.header-top .nav-top-right li.ant-menu-item.ant-menu-item-selected:active a:before {
  opacity: 1;
}
.header-top .nav-top-right li:last-child {
  margin-right: 0;
  margin-left: 12px;
}
.header-top .nav-top-right li:last-child:hover {
  border-color: transparent;
}
.header-top .nav-top-right li:last-child:focus {
  outline: none;
  box-shadow: none;
}
.header-top .nav-top-right li:last-child:active {
  border-color: transparent;
}
.header-top .nav-top-right li:last-child:last-child::before {
  height: 24px;
  width: 1px;
  position: absolute;
  left: 6px;
  top: 17px;
  background: #d8d8d8;
  content: "";
}
.header-top .nav-top-right .ant-btn {
  font-weight: 500;
  font-size: 14px;
  color: #13171f;
  line-height: 34px;
  margin: 10px 0px;
  padding-bottom: 0;
  padding-top: 0;
  height: 34px;
}
.header-top .nav-top-right .ant-btn span {
  line-height: 30px;
}
.header-top .nav-top-right .ant-btn:hover {
  color: #4cb8ac;
  border-color: #4cb8ac;
}
.header-top .nav-top-right .ant-btn:focus {
  outline: none;
  box-shadow: none;
}
.header-top .nav-top-right .ant-btn:active {
  border-color: #4cb8ac;
}
.header-top .nav-top-right li button.ant-btn {
  color: #fff;
  border-color: #fff;
  letter-spacing: 0;
  text-transform: uppercase;
}
.header-top .nav-top-right li button.ant-btn:hover {
  color: #4cb8ac;
  border-color: #4cb8ac;
}
.header-top .nav-top-right li button.ant-btn:focus {
  color: #4cb8ac;
  border-color: #4cb8ac;
}
.header-top .nav-top-right li button.ant-btn:active {
  color: #4cb8ac;
  border-color: #4cb8ac;
}
.header-top .nav-top-right li .top-nav-dropdown {
  min-width: 176px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: right;
}
.header-top .nav-top-right li .top-nav-dropdown .ant-dropdown-link {
  color: #fff;
  font-size: 16px;
}
.header-top .nav-top-right li .top-nav-dropdown .ant-dropdown-link i {
  color: #4cb8ac;
  font-size: 16px;
}
.header-top .nav-top-right li .top-nav-dropdown .account-icon {
  display: inline-block;
  width: 32px;
  height: 32px;
  border: solid 1px #e5e5e5;
  border-radius: 50%;
  vertical-align: middle;
  text-align: center;
  margin-right: 14px;
  background: #fff;
  margin-top: 0px;
  font-size: 12px;
  font-weight: 500;
  line-height: 32px;
  color: #13171f;
}
.header-top .nav-top-right li .top-nav-dropdown .account-icon span {
  font-size: 12px;
  color: #4cb8ac;
  display: block;
  line-height: 32px;
  font-weight: 500;
}
.header-top .nav-top-right li .top-nav-dropdown span.username {
  display: inline-block;
  margin-right: 8px;
  width: 150px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  text-transform: none;
  font-size: 16px;
  letter-spacing: 0;
}
.header-top .nav-top-right li .top-nav-dropdown .user-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0px;
  display: block;
}
.header-top .nav-top-right li .top-nav-dropdown i {
  color: #4cb8ac;
  font-size: 16px;
}

.header-top-colored {
  background-color: #d3e2e1;
  border-bottom: solid 1px #c9dad9;
}
.header-top-colored .rev-Brand-img {
  display: none;
}
.header-top-colored .dark-Brand-img {
  display: block;
}
.header-top-colored .nav-top li {
  color: #1f2124;
}
.header-top-colored .nav-top li a {
  color: #1f2124;
}
.header-top-colored .nav-top li a:hover:before {
  background: #4cb8ac;
}
.header-top-colored .nav-top-right li {
  color: #3b414d;
}
.header-top-colored .nav-top-right li a {
  color: #3b414d;
}
.header-top-colored .nav-top-right li a:hover:before {
  background: #13171f;
}
.header-top-colored .nav-top-right li a:before {
  background: #13171f;
}
.header-top-colored .nav-top-right li button.ant-btn {
  color: #4CB8AC;
  border-color: #4CB8AC;
}
.header-top-colored .nav-top-right li button.ant-btn:hover {
  color: #13171f;
  border-color: #13171f;
}

.ant-dropdown-menu {
  border-radius: 0px 0px 4px 4px;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  padding: 0px;
  margin: 0px;
  list-style: none;
  width: 213px;
  max-width: 213px;
  right: 0px;
}
.ant-dropdown-menu li {
  border-top: 1px solid #efefef;
  padding: 0px;
  background-color: #fff;
}
.ant-dropdown-menu li a {
  color: #4cb8ac;
  font-weight: 500;
  font-size: 16px;
  display: block;
  text-align: center;
  padding: 15px 12px;
  margin: 0px;
  line-height: 20px;
}
.ant-dropdown-menu li a:active {
  color: #4cb8ac;
}
.ant-dropdown-menu li a:focus {
  color: #4cb8ac;
}
.ant-dropdown-menu li a:active {
  color: #4cb8ac;
}
.ant-dropdown-menu li:first-child {
  border-top: none;
}
.ant-dropdown-menu li.ant-dropdown-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-dropdown-menu li.ant-dropdown-menu-item:hover {
  background-color: #e6f7ff;
  outline: none;
}
.ant-dropdown-menu li.ant-dropdown-menu-item-selected {
  background-color: #e6f7ff;
  outline: none;
}
.ant-dropdown-menu li.ant-dropdown-menu-item-selected a {
  background: transparent !important;
  color: #4cb8ac !important;
  outline: none;
}

.full-logo.active:before {
  opacity: 1;
}

.header-top.nav-active .full-logo.active:before {
  background: #13192d;
  opacity: 1;
}

.header-top.nav-active {
  background: #fff;
  border-bottom: solid 1px #efefef;
}
.header-top.nav-active .nav-top li {
  color: #13192d;
}
.header-top.nav-active .nav-top li a {
  color: #13192d;
}
.header-top.nav-active .nav-top li a:before {
  background: #13192d;
}
.header-top.nav-active .nav-top li:hover {
  color: #13192d;
}
.header-top.nav-active .nav-top li:hover a {
  color: #13192d;
}
.header-top.nav-active .nav-top li:hover a:before {
  background: #13192d;
}
.header-top.nav-active .nav-top li:focus {
  color: #13192d;
}
.header-top.nav-active .nav-top li:focus a {
  color: #13192d;
}
.header-top.nav-active .nav-top li:focus a:before {
  background: #13192d;
}
.header-top.nav-active .nav-top li:active {
  color: #13192d;
}
.header-top.nav-active .nav-top li:active a {
  color: #13192d;
}
.header-top.nav-active .nav-top li:active a:before {
  background: #13192d;
}
.header-top.nav-active .nav-top-right li button.ant-btn {
  color: #4cb8ac;
  border-color: #4cb8ac;
}
.header-top.nav-active .nav-top-right li button.ant-btn:hover {
  color: #13171f;
  border-color: #13171f;
}
.header-top.nav-active .nav-top-right li button.ant-btn:focus {
  color: #13171f;
  border-color: #13171f;
}
.header-top.nav-active .nav-top-right li button.ant-btn:active {
  color: #13171f;
  border-color: #13171f;
}
.header-top.nav-active .nav-top-right li a {
  color: #13171f;
}
.header-top.nav-active .nav-top-right li a:before {
  background: transparent;
}
.header-top.nav-active .nav-top-right li:hover a:before {
  background: transparent;
}
.header-top.nav-active .nav-top-right li:first-child::before {
  background: #13192d;
}
.header-top.nav-active .nav-top-right li:last-child {
  margin-right: 0px;
  padding-right: 0px;
}
.header-top.nav-active .nav-top-right li:last-child:hover {
  border-color: transparent;
}
.header-top.nav-active .nav-top-right li:last-child:focus {
  outline: none;
  box-shadow: none;
}
.header-top.nav-active .nav-top-right li:last-child:active {
  border-color: transparent;
}
.header-top.nav-active .nav-top-right li:last-child:before {
  content: none;
  display: none;
}
.header-top.nav-active .nav-top-right li .top-nav-dropdown .user-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0px;
  display: block;
}
.header-top.nav-active .nav-top-right li .top-nav-dropdown .ant-dropdown-link {
  color: #13171f;
}
.header-top.nav-active .nav-top-right li .top-nav-dropdown .ant-dropdown-link i {
  color: #4cb8ac;
}
.header-top.nav-active .nav-top-right li .top-nav-dropdown .account-icon {
  display: inline-block;
  width: 32px;
  height: 32px;
  border: solid 1px #e5e5e5;
  border-radius: 50%;
  vertical-align: middle;
  text-align: center;
  margin-right: 8px;
  background: #fff;
  margin-top: 0px;
  font-size: 12px;
  font-weight: 500;
  line-height: 32px;
  color: #13171f;
}
.header-top.nav-active .nav-top-right li .top-nav-dropdown .account-icon span {
  font-size: 12px;
  color: #4cb8ac;
  display: block;
  line-height: 32px;
  font-weight: 500;
  padding-top: 0;
  padding-bottom: 0;
}
.header-top.nav-active .nav-top-right li .top-nav-dropdown i {
  color: #4cb8ac;
  font-size: 16px;
}
.header-top.nav-active .nav-top-right li.ant-menu-item-selected:last-child {
  margin-right: 0px;
}
.header-top.nav-active .nav-top-right li.ant-menu-item-selected:last-child:hover {
  border-color: transparent;
}
.header-top.nav-active .nav-top-right li.ant-menu-item-selected:last-child:focus {
  outline: none;
  box-shadow: none;
}
.header-top.nav-active .nav-top-right li.ant-menu-item-selected:last-child:active {
  border-color: transparent;
}
.header-top.nav-active .nav-top-right .ant-btn {
  border-color: #4cb8ac;
  color: #4cb8ac;
}
.header-top.nav-active .nav-top-right .ant-btn:hover {
  color: #13192d;
  border-color: #13192d;
}
.header-top.nav-active .nav-top-right .ant-btn:focus {
  outline: none;
  box-shadow: none;
}
.header-top.nav-active .nav-top-right .ant-btn:active {
  border-color: #13192d;
}
.header-top.nav-active .nav-top-right .table-dropdown a {
  color: #4cb8ac;
  font-weight: 500;
  font-size: 16px;
}
.header-top.nav-active .nav-top-right .table-dropdown a i {
  font-size: 20px;
}
.header-top.nav-active .nav-top-right .table-dropdown a:before {
  content: none;
}
.header-top.nav-active .full-logo .rev-Brand-img {
  display: none;
}
.header-top.nav-active .full-logo .dark-Brand-img {
  display: block;
}

.header-top.nologin .nav-top-right li:first-child {
  position: relative;
}
.header-top.nologin .nav-top-right li:first-child:before {
  height: 24px;
  width: 1px;
  position: absolute;
  right: 0px;
  top: 17px;
  background: #d8d8d8;
  content: "";
  content: none;
}
.header-top.nologin .nav-top-right li:last-child:before {
  content: none;
  display: none;
}

@media only screen and (max-width: 992px) {
  .container {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .ant-col-offset-6 {
    margin-left: 0px !important;
  }
  section.HomeBanner {
    padding: 0px 15px;
  }
  .heading-top {
    padding: 42px 0px 0px 0px;
  }
  .second-heading {
    margin-top: 14px;
  }
  button.home-btn {
    margin-bottom: 25px;
  }
  .what-we-do {
    text-align: center;
    padding: 15px 25px 30px 25px;
  }
  .inner-mls-features {
    padding: 40px 25px;
  }
  section.how-it-works {
    padding: 30px 25px;
  }
  .questions {
    padding: 42px 25px;
  }
}
@media only screen and (max-width: 1280px) and (min-width: 720px) {
  .header-top .nav-top-right li {
    padding: 0px 17px;
  }
}
@media only screen and (max-width: 1265px) and (min-width: 1031px) {
  .header-top .nav-top li {
    margin-left: 10px;
    margin-right: 10px;
  }
  .header-top .nav-top-right li {
    padding: 0px 10px;
  }
}
@media only screen and (max-width: 1030px) and (min-width: 481px) {
  .ant-dropdown-menu {
    width: 162px;
    max-width: 162px;
    right: 0px;
    top: 15px;
  }
  .full-logo {
    margin: 0;
  }
  .full-logo:before {
    left: 2px;
  }
  .mobile-signup {
    display: block;
  }
  .mobile-signup button {
    background: transparent;
    color: #54baac;
    border: 1px solid #54baac;
    font-weight: 500;
    padding: 5px 11px;
    width: auto;
    letter-spacing: normal;
    display: block;
    float: right;
    margin-top: 15px;
    border-radius: 4px;
  }
  .mobile-menu-icon {
    display: block;
  }
  .mobile-menu-icon img {
    float: left;
    margin: 27px 12px 0px 0px;
    width: 22px;
    filter: invert(1);
  }
  .header-top .nav-top {
    display: none;
  }
  .header-top .nav-top-right {
    display: none;
  }
  .mobile-menu {
    height: auto;
    background-color: #ffffff;
    position: fixed;
    z-index: 1004;
    width: 100%;
    transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    opacity: 1;
  }
  .mobile-menu .ant-layout-header {
    height: 60px;
    padding: 0px 15px;
    border: solid 1px rgba(255, 255, 255, 0.13);
    background: #ffffff;
  }
  .mobile-menu .ant-layout-header .close img {
    position: absolute;
    top: 23px;
    margin: 0px;
    width: 14px;
    height: 14px;
  }
  .mobile-menu .ant-layout-header .menu-logo {
    height: 24px;
    width: auto;
    margin-top: 0px;
    margin-bottom: 8px;
    margin-left: 8px;
  }
  .mobile-menu .ant-layout-header button {
    float: right;
    margin-top: 10px;
    background: transparent;
    color: #54baac;
    border: 1px solid #54baac;
    font-weight: 500;
    padding: 5px 11px;
    width: auto;
    letter-spacing: normal;
    margin-top: 14px;
    margin-bottom: 0px;
    margin-right: -25px;
  }
  .mobile-menu ul {
    list-style: none;
    text-align: left;
    font-size: 24px;
    font-weight: 500;
    padding: 0px;
    margin: 0;
    color: #1f2124;
  }
  .mobile-menu ul li {
    margin: 0px;
    padding: 30px 20px 15px;
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #CCD8DB;
  }
  .mobile-menu ul .dropdown {
    position: relative;
  }
  .mobile-menu ul .dropdown:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 18px;
    height: 18px;
    background: url("/assets/images/icons/sub-menu-arrow.svg");
    background-size: contain;
  }
  .mobile-menu ul .dropdown-item {
    position: fixed;
    top: 0;
    z-index: 1;
    padding: 20px 0;
    height: calc(100vh - 40px);
  }
  .mobile-menu ul li:first-child {
    padding: 11px 20px 15px;
    border: none;
  }
  .mobile-menu ul li:last-child {
    margin: 0;
  }
  .mobile-menu .mob-btn {
    margin: 0;
    background-color: #F5F7F9;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
  }
  .mobile-menu button {
    width: 50%;
    height: auto;
    padding: 13px;
    background: transparent;
    color: #1f2124;
    letter-spacing: 1px;
    font-weight: 500;
    margin: 0;
    border: none;
    border-left: 1px solid #E5E5E5;
    border-radius: 0;
    text-align: left;
  }
  .mobile-menu button:first-child {
    border: none;
    text-align: right;
  }
  .mobile-menu .property {
    width: 100%;
    padding: 13px;
    height: auto;
    background: #4cb8ac;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
    margin-top: 0px;
    border: none;
  }
  .mobile-signup .mobile-dropdown {
    border: none;
    background: transparent;
    line-height: 60px;
    height: 60px;
    display: block;
    text-align: right;
  }
  .mobile-signup .mobile-dropdown li {
    margin: 0px;
    border: none;
    padding: 0px 0px;
  }
  .mobile-signup .mobile-dropdown li a {
    color: #111111;
  }
  .mobile-signup .mobile-dropdown .account-icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    border: solid 1px #e5e5e5;
    border-radius: 50%;
    vertical-align: middle;
    text-align: center;
    margin-right: 8px;
    background: #fff;
    margin-top: 0px;
    font-size: 12px;
    font-weight: 500;
    line-height: 32px;
    color: #13171f;
  }
  .mobile-signup .mobile-dropdown .account-icon span {
    color: #111;
  }
  .mobile-signup .mobile-dropdown .username {
    margin-right: 8px;
    width: 60px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
  }
  .mobile-signup .mobile-dropdown .user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 0px;
    display: block;
  }
  .header-top.nav-active .mobile-dropdown li a {
    color: #111;
  }
  .header-top.nav-active .mobile-dropdown li i {
    color: #4cb8ac;
  }
}
@media (max-width: 480px) {
  .full-logo:before {
    height: 0;
  }
  .full-logo img {
    max-width: 85px;
    max-height: 31.9px;
  }
  .header-top-colored .mobile-menu-icon img {
    filter: invert(1);
  }
  .header-top-colored .mobile-signup .mobile-dropdown li a {
    color: #111111;
  }
  .ant-dropdown-menu {
    width: 162px;
    max-width: 162px;
    right: 0px;
    top: 15px;
  }
  .full-logo {
    margin: 0;
  }
  .full-logo:before {
    left: 2px;
  }
  .mobile-signup {
    display: block;
  }
  .mobile-signup button {
    background: transparent;
    color: #54baac;
    border: 1px solid #54baac;
    font-weight: 500;
    padding: 0px 20px;
    width: auto;
    letter-spacing: normal;
    display: block;
    float: right;
    margin-top: 15px;
    border-radius: 25px;
    height: 30px;
  }
  .mobile-menu-icon {
    display: block;
  }
  .mobile-menu-icon img {
    float: left;
    margin: 27px 20px 0px 0px;
    width: 22px;
  }
  .header-top .nav-top {
    display: none;
  }
  .header-top .nav-top-right {
    display: none;
  }
  .mobile-menu {
    height: auto;
    background-color: #ffffff;
    position: fixed;
    z-index: 1004;
    width: 100%;
    transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    opacity: 1;
    overflow-y: auto;
    top: 0px;
  }
  .mobile-menu img {
    margin-top: -10px;
    max-width: 79px;
    margin-left: 13px;
    height: 25px;
  }
  .mobile-menu .ant-layout-header {
    height: 60px;
    padding: 0px 0 0 20px;
    background: #ffffff;
    border: solid 1px rgba(255, 255, 255, 0.13);
  }
  .mobile-menu .ant-layout-header .close img {
    position: absolute;
    width: 20px;
    top: 18px;
    left: 1px;
    margin: 0px;
  }
  .mobile-menu .ant-layout-header .menu-logo {
    height: 24px;
    width: auto;
    margin-top: 0px;
    margin-bottom: 8px;
    margin-left: 8px;
  }
  .mobile-menu .ant-layout-header button {
    background: transparent;
    color: #54baac;
    border: 1px solid #54baac;
    font-weight: 500;
    padding: 0px 20px;
    width: auto;
    letter-spacing: normal;
    display: block;
    float: right;
    border-radius: 25px;
    line-height: 16px;
    margin-top: 14px;
    margin-right: -24px;
    height: 30px;
  }
  .mobile-menu ul {
    list-style: none;
    text-align: left;
    font-size: 24px;
    font-weight: 500;
    padding: 0px;
    margin: 0;
    color: #1f2124;
  }
  .mobile-menu ul li {
    margin: 0;
    padding: 30px 20px 15px;
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #CCD8DB;
  }
  .mobile-menu ul .dropdown {
    position: relative;
  }
  .mobile-menu ul .dropdown:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 18px;
    height: 18px;
    background: url("/assets/images/icons/sub-menu-arrow.svg");
    background-size: contain;
  }
  .mobile-menu ul .dropdown-item {
    position: fixed;
    top: 0;
    z-index: 1;
    padding: 0 0 40px 0;
    height: 100vh;
    width: 100%;
    background-color: #ffffff;
    overflow-y: auto;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down {
    padding: 60px 15px 20px;
    position: relative;
    left: auto;
    flex-direction: column;
    gap: 24px;
    box-shadow: none;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down h4 {
    color: #7C8189;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 16px;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-item {
    margin: 0px 0px 4px 0px;
    padding: 0px 0px 29px 0px;
    border-bottom: 1px solid #CCD8DB;
    gap: 18px;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-item img {
    margin: 0px;
    max-width: unset;
    height: auto;
    max-height: 40px;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-item h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: #3b414d;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-item p {
    font-size: 14px;
    font-weight: 300;
    line-height: 16px;
    color: #3b414d;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-item.no-border {
    border-bottom: none;
    padding-bottom: 10px;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-sec {
    text-align: center;
    align-items: center;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-sec img {
    width: auto;
    max-width: unset;
    height: auto;
    margin: 0 auto;
  }
  .mobile-menu ul .dropdown-item .nav-drop-down .learn-dropdown-sec .listbutton {
    padding: 0px 80px 0px 81px;
    font-size: 14px;
    line-height: 48px;
    width: auto;
    margin-bottom: 19px;
  }
  .mobile-menu ul .dropdown-item .close-button {
    top: 16px;
    margin-top: 0;
    left: 15px;
    opacity: 1;
    z-index: 9999;
    pointer-events: all;
    position: fixed;
  }
  .mobile-menu ul .dropdown-item .close-button img {
    margin: 0 0 0 3px;
    width: 11.65px;
    height: auto;
    max-width: 11.65px;
  }
  .mobile-menu ul .dropdown-item .mob-btn button {
    padding: 24.5px 35px;
  }
  .mobile-menu ul li:first-child {
    padding: 11px 20px 15px;
    border: none;
  }
  .mobile-menu ul li:last-child {
    margin: 0;
  }
  .mobile-menu .mob-btn {
    margin: 0;
    background-color: #F5F7F9;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
  }
  .mobile-menu button {
    width: 50%;
    height: auto;
    padding: 13px;
    background: transparent;
    color: #1f2124;
    letter-spacing: 1px;
    font-weight: 500;
    margin: 0;
    border: none;
    border-left: 1px solid #E5E5E5;
    border-radius: 0;
    text-align: left;
  }
  .mobile-menu button:first-child {
    border: none;
    text-align: right;
  }
  .mobile-menu .property {
    width: 100%;
    padding: 13px;
    height: auto;
    background: #4cb8ac;
    color: #fff;
    font-weight: bold;
    letter-spacing: 1px;
    margin-top: 0px;
    border: none;
  }
  .mobile-signup .mobile-dropdown {
    border: none;
    background: transparent;
    line-height: 60px;
    height: 60px;
    display: block;
    text-align: right;
  }
  .mobile-signup .mobile-dropdown li {
    margin: 0px;
    border: none;
    padding: 0px 0px;
  }
  .mobile-signup .mobile-dropdown li a {
    color: #111111;
  }
  .mobile-signup .mobile-dropdown .account-icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    border: solid 1px #e5e5e5;
    border-radius: 50%;
    vertical-align: middle;
    text-align: center;
    margin-right: 8px;
    background: #fff;
    margin-top: 0px;
    font-size: 12px;
    font-weight: 500;
    line-height: 32px;
    color: #13171f;
  }
  .mobile-signup .mobile-dropdown .account-icon span {
    color: #111;
  }
  .mobile-signup .mobile-dropdown .username {
    margin-right: 8px;
    width: 60px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
  }
  .mobile-signup .mobile-dropdown .user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin: 0px;
    display: block;
  }
  .header-top.nav-active .mobile-dropdown li a {
    color: #111111;
  }
  .header-top.nav-active .mobile-dropdown li i {
    color: #4cb8ac;
  }
}
.nav-drop-down {
  position: absolute;
  left: 0;
  z-index: 222;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: #212529;
  background-color: #fff;
  border: none;
  justify-content: center;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  gap: 40px;
  padding: 24px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.19);
}
.nav-drop-down .col-section {
  flex: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0px;
}
.nav-drop-down .col-section .learn-dropdown-item {
  color: #13171F;
  height: auto;
  padding: 18px;
  width: 100%;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  min-width: 340px;
  gap: 20px;
}
.nav-drop-down .col-section .learn-dropdown-item:hover {
  background: transparent none;
}
.nav-drop-down .col-section .learn-dropdown-item .text {
  flex-grow: 1;
}
.nav-drop-down .col-section .learn-dropdown-item h2 {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 0 0 2px 0;
  padding: 0;
  color: #3B414D;
}
.nav-drop-down .col-section .learn-dropdown-item p {
  font-size: 14px;
  line-height: 19px;
  font-weight: 300;
  margin: 0;
  padding: 0;
  color: #3B414D;
}
.nav-drop-down .col-section .learn-dropdown-sec {
  color: #13171F;
  height: auto;
  padding: 0 16px 0 0;
  width: 100%;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  cursor: auto;
}
.nav-drop-down .col-section .learn-dropdown-sec img {
  width: 198px;
  height: 179px;
}
.nav-drop-down .col-section .learn-dropdown-sec h2 {
  font-size: 28px;
  line-height: 32.81px;
  font-weight: 400;
  margin: 0 0 4px 0;
  padding: 0;
  color: #13171F;
}
.nav-drop-down .col-section .learn-dropdown-sec h2 strong {
  font-weight: 700;
}
.nav-drop-down .col-section .learn-dropdown-sec .listbutton {
  margin: 0;
  position: relative;
  padding: 14.8px 79px 14.8px 79.2px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.41px;
  letter-spacing: 1px;
  text-align: center;
  height: auto;
  background-color: #4cb8ac;
  border: 1px solid #4cb8ac;
  color: #ffffff;
}
.nav-drop-down .col-section .learn-dropdown-sec .listbutton:focus, .nav-drop-down .col-section .learn-dropdown-sec .listbutton:hover {
  outline: none;
  height: auto;
  background-color: #ffffff;
  border-color: #4cb8ac;
  color: #4cb8ac;
}

.nav-drop-down.research-drop-down {
  margin-left: -150px;
}

.nav-drop-down.whyfalaya-drop-down {
  margin-left: -175px;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/layout/components/topnavbar/topnavbar.component.scss"],"names":[],"mappings":"AAAA,8EAAA;AAQA,0BAAA;ACLA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACC,aAAA;EACD,mBAAA;AACF;AAAE;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AAEJ;AAAE;EACE,eAAA;EACA,YAAA;EAEA,cAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;EACA,gBAAA;AADJ;AAGE;EAEE,cAAA;EACA,eAAA;AAFJ;AAII;EACE,aAAA;EACA,gBAAA;AAFN;AAME;EACE,aAAA;AAJJ;AAMI;EACE,aAAA;EACA,gBAAA;AAJN;;AAQA;EACE,gBDnCc;ECoCd,eAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,kDAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;AALF;AAOE;EACE,gBD/CY;ECgDZ,iBAAA;EACA,YAAA;AALJ;AAOI;EACE,WDxEE;ECyEF,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AALN;AAMM;EACE,aAAA;AAJR;AAOQ;EACA,sBAAA;AALR;AASQ;EACA,wBAAA;AAPR;AAUM;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WDnGA;ECoGA,eAAA;EACA,iBAAA;AARR;AASQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AAPV;AAUM;EAIE,WAAA;AAXR;AAQQ;EACE,mBAAA;AANV;AAWU;EACE,UAAA;AATZ;AAcM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAZR;AAeU;EACE,UAAA;AAbZ;AAkBM;EACE,WAAA;EACA,uBAAA;AAhBR;AAmBU;EACE,UAAA;AAjBZ;AAuBI;EACE,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBD5JE;ACuIR;AAwBQ;EACE,UAAA;AAtBV;AA0BM;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AAxBR;AA2BU;EACE,UAAA;AAzBZ;AA8BM;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AA5BR;AA+BU;EACE,UAAA;AA7BZ;AAoCE;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AAlCJ;AAoCI;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAlCN;AAsCM;EACE,eAAA;EACA,gBAAA;EACA,WDrNA;ECsNA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AApCR;AAqCQ;EACE,iBAAA;EACA,cAAA;EACA,aD7NA;EC8NA,YAAA;AAnCV;AAsCQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EAGA,mBAAA;EACA,UAAA;EACA,SAAA;AAtCV;AAyCM;EAIE,WAAA;AA1CR;AAuCQ;EACE,mBAAA;AArCV;AA0CU;EACE,UAAA;EACA,6BAAA;AAxCZ;AA2CY;EACE,6BAAA;AAzCd;AAgDM;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AA9CR;AAiDU;EACE,UAAA;EACA,6BAAA;AA/CZ;AAqDM;EACE,WAAA;EACA,uBAAA;AAnDR;AAsDU;EACE,UAAA;AApDZ;AAyDQ;EACE,mBAAA;AAvDV;AA2DI;EACE,aAAA;AAzDN;AA4DI;EACE,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBD5SE;ACkPR;AA6DQ;EACE,UAAA;AA3DV;AA+DM;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AA7DR;AAgEU;EACE,UAAA;AA9DZ;AAmEM;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AAjER;AAoEU;EACE,UAAA;AAlEZ;AAwEI;EACE,eAAA;EACA,iBAAA;AAtEN;AAuEM;EACE,yBAAA;AArER;AAuEM;EACE,aAAA;EACA,gBAAA;AArER;AAwEM;EACE,yBAAA;AAtER;AAyEM;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EAEA,WAAA;AAxER;AA4EI;EACE,gBAAA;EACA,eAAA;EACA,cDxVU;ECyVV,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AA1EN;AA2EM;EACE,iBAAA;AAzER;AA4EM;EACE,cDtXE;ECuXF,qBDvXE;AC6SV;AA6EM;EACE,aAAA;EACA,gBAAA;AA3ER;AA8EM;EACE,qBDhYE;ACoTV;AAiFM;EACE,WDxYA;ECyYA,kBDzYA;EC2YA,iBAAA;EACA,yBAAA;AAhFR;AAiFQ;EACE,cD5YA;EC6YA,qBD7YA;AC8TV;AAkFQ;EACE,cDjZA;ECkZA,qBDlZA;ACkUV;AAmFQ;EACE,cDtZA;ECuZA,qBDvZA;ACsUV;AAuFM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AArFR;AAuFQ;EACE,WDxaF;ECyaE,eAAA;AArFV;AAuFU;EACE,cD1aF;EC2aE,eAAA;AArFZ;AAyFQ;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBD1bF;EC2bE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAvFV;AAwFU;EACE,eAAA;EACA,cDhcF;ECicE,cAAA;EACA,iBAAA;EACA,gBAAA;AAtFZ;AAyFQ;EACE,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;AAvFV;AAyFQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAvFV;AA0FQ;EACE,cD5dA;EC6dA,eAAA;AAxFV;;AA8FA;EAGA,yBAAA;EACA,gCAAA;AA7FA;AA8FA;EACE,aAAA;AA5FF;AA8FA;EACE,cAAA;AA5FF;AA+FE;EAEI,cAAA;AA9FN;AA+FI;EAEE,cAAA;AA9FN;AAgGQ;EAEM,mBAAA;AA/Fd;AAwGI;EAEA,cAAA;AAvGJ;AAwGM;EAEA,cAAA;AAvGN;AAyGY;EACE,mBAAA;AAvGd;AA0GQ;EACA,mBAAA;AAxGR;AA2GQ;EAGE,cAAA;EACA,qBAAA;AA3GV;AA4GU;EACE,cAAA;EACA,qBAAA;AA1GZ;;AAiHA;EACE,8BAAA;EACA,4CAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EAEA,UAAA;AA/GF;AAiHE;EACE,6BAAA;EACA,YAAA;EACA,sBD9iBI;AC+bR;AAgHI;EACE,cD9iBI;EC+iBJ,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AA9GN;AAgHM;EACE,cDxjBE;AC0cV;AAiHM;EACE,cD5jBE;AC6cV;AAkHM;EACE,cDhkBE;ACgdV;AAqHE;EACE,gBAAA;AAnHJ;AAqHE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnHJ;AAoHI;EACE,yBAAA;EACA,aAAA;AAlHN;AAqHE;EACE,yBAAA;EACA,aAAA;AAnHJ;AAoHI;EACE,kCAAA;EACA,yBAAA;EACA,aAAA;AAlHN;;AAwHE;EACE,UAAA;AArHJ;;AA2HI;EACE,mBD3mBC;EC4mBD,UAAA;AAxHN;;AA6HA;EACE,gBD/mBM;ECgnBN,gCAAA;AA1HF;AA6HI;EACE,cDvnBC;AC4fP;AA6HM;EACE,cD1nBD;AC+fP;AA6HQ;EACE,mBD7nBH;ACkgBP;AA+HM;EACE,cDloBD;ACqgBP;AA+HQ;EACE,cDroBH;ACwgBP;AA+HU;EACE,mBDxoBL;AC2gBP;AAkIM;EACE,cD9oBD;AC8gBP;AAkIQ;EACE,cDjpBH;ACihBP;AAkIU;EACE,mBDppBL;ACohBP;AAqIM;EACE,cD1pBD;ACuhBP;AAqIQ;EACE,cD7pBH;AC0hBP;AAqIU;EACE,mBDhqBL;AC6hBP;AA4IM;EACE,cDrqBE;ECsqBF,qBDtqBE;AC4hBV;AA4IQ;EACE,cDtpBM;ECupBN,qBDvpBM;AC6gBhB;AA6IQ;EACE,cD3pBM;EC4pBN,qBD5pBM;ACihBhB;AA8IQ;EACE,cDhqBM;ECiqBN,qBDjqBM;ACqhBhB;AA+IM;EACE,cDrqBQ;ACwhBhB;AA8IQ;EAEE,uBAAA;AA7IV;AAmJU;EAEE,uBAAA;AAlJZ;AAsJM;EACE,mBD7sBD;ACyjBP;AAsJM;EACE,iBAAA;EACA,kBAAA;AApJR;AAsJQ;EACE,yBAAA;AApJV;AAuJQ;EACE,aAAA;EACA,gBAAA;AArJV;AAwJQ;EACE,yBAAA;AAtJV;AAyJQ;EACE,aAAA;EACA,aAAA;AAvJV;AA4JQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AA1JV;AA6JQ;EACE,cDxtBM;AC6jBhB;AA6JU;EACE,cD9uBF;ACmlBV;AA+JQ;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBD7vBF;EC8vBE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA7JV;AA+JU;EACE,eAAA;EACA,cDpwBF;ECqwBE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA7JZ;AAiKQ;EACE,cD9wBA;EC+wBA,eAAA;AA/JV;AAqKM;EACE,iBAAA;AAnKR;AAqKQ;EACE,yBAAA;AAnKV;AAsKQ;EACE,aAAA;EACA,gBAAA;AApKV;AAuKQ;EACE,yBAAA;AArKV;AA2KI;EACE,qBDzyBI;EC0yBJ,cD1yBI;ACioBV;AA2KM;EACE,cDlzBD;ECmzBC,qBDnzBD;AC0oBP;AA4KM;EACE,aAAA;EACA,gBAAA;AA1KR;AA6KM;EACE,qBD5zBD;ACipBP;AA+KM;EACE,cD5zBE;EC6zBF,gBAAA;EACA,eAAA;AA7KR;AA+KQ;EACE,eAAA;AA7KV;AAgLQ;EACE,aAAA;AA9KV;AAqLI;EACE,aAAA;AAnLN;AAsLI;EACE,cAAA;AApLN;;AA4LM;EACE,kBAAA;AAzLR;AA0LQ;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AAxLR;AA4LQ;EACE,aAAA;EACA,aAAA;AA1LV;;AAiMA;EACE;IACE,WAAA;EA9LF;AACF;AAiMA;EACE;IACE,2BAAA;EA/LF;EAkMA;IACE,iBAAA;EAhMF;EAmMA;IACE,yBAAA;EAjMF;EAoMA;IACE,gBAAA;EAlMF;EAqMA;IACE,mBAAA;EAnMF;EAsMA;IACE,kBAAA;IACA,4BAAA;EApMF;EAuMA;IACE,kBAAA;EArMF;EAwMA;IACE,kBAAA;EAtMF;EAyMA;IACE,kBAAA;EAvMF;AACF;AA0MA;EAGM;IACA,iBAAA;EA1MJ;AACF;AA8MA;EAIM;IACE,iBAAA;IACA,kBAAA;EA/MN;EAoNI;IACE,iBAAA;EAlNN;AACF;AAuNA;EACE;IACE,YAAA;IACA,gBAAA;IACA,UAAA;IACA,SAAA;EArNF;EAuNA;IACE,SAAA;EArNF;EAsNE;IACE,SAAA;EApNJ;EAwNA;IACE,cAAA;EAtNF;EAuNE;IACE,uBAAA;IACA,cAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,sBAAA;IACA,cAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EArNJ;EAyNA;IACE,cAAA;EAvNF;EAwNE;IACE,WAAA;IAEA,yBAAA;IACA,WAAA;IACA,iBAAA;EAvNJ;EA4NE;IACE,aAAA;EA1NJ;EA6NE;IACE,aAAA;EA3NJ;EA+NA;IACE,YAAA;IAIA,yBAAA;IACA,eAAA;IACA,aAAA;IACA,WAAA;IACA,iEAAA;IACA,UAAA;EAhOF;EAsOE;IACE,YAAA;IACA,iBAAA;IAEA,2CAAA;IACA,mBAAA;EArOJ;EAuOM;IACE,kBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EArOR;EAyOI;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;EAvON;EA0OI;IACE,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,cAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;EAxON;EA4OE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,SAAA;IAEA,cAAA;EA3OJ;EA6OI;IAGE,WAAA;IACA,uBAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,6BAAA;EA7ON;EA+OI;IACE,kBAAA;EA7ON;EA8OM;IACE,WAAA;IACA,qBAAA;IACA,sBAAA;IACA,WAAA;IACA,YAAA;IACA,0DAAA;IACA,wBAAA;EA5OR;EA+OI;IACE,eAAA;IACA,MAAA;IACA,UAAA;IACA,eAAA;IACA,0BAAA;EA7ON;EA+OI;IACE,uBAAA;IACA,YAAA;EA7ON;EA+OI;IACE,SAAA;EA7ON;EAiPE;IACE,SAAA;IACA,yBAAA;IACA,yBAAA;IACA,aAAA;IACA,mBAAA;EA/OJ;EAkPE;IACE,UAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;IAGA,SAAA;IACA,YAAA;IACA,8BAAA;IACA,gBAAA;IACA,gBAAA;EAlPJ;EAqPE;IACE,YAAA;IACA,iBAAA;EAnPJ;EAsPE;IACE,WAAA;IACA,aAAA;IACA,YAAA;IACA,mBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;IACA,eAAA;IACA,YAAA;EApPJ;EAwPE;IACE,YAAA;IACA,uBAAA;IACA,iBAAA;IACA,YAAA;IACA,cAAA;IACA,iBAAA;EAtPJ;EAuPI;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EArPN;EAsPM;IAEE,cAAA;EArPR;EAwPI;IACE,qBAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IAEA,eAAA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,cAAA;EAvPR;EAyPM;IAGE,WAAA;EAzPR;EA+PI;IACE,iBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,sBAAA;EA7PN;EA+PI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;EA7PN;EAoQM;IACE,WAAA;EAlQR;EAoQM;IACE,cAAA;EAlQR;AACF;AA0QA;EAEI;IACE,SAAA;EAzQJ;EA2QE;IACE,eAAA;IACA,kBAAA;EAzQJ;EAgRI;IAEE,iBAAA;EA/QN;EAqRQ;IACE,cAAA;EAnRV;EAyRA;IACE,YAAA;IACA,gBAAA;IACA,UAAA;IACA,SAAA;EAvRF;EAyRA;IACE,SAAA;EAvRF;EAwRE;IACE,SAAA;EAtRJ;EA0RA;IACE,cAAA;EAxRF;EAyRE;IACE,uBAAA;IACA,cAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,sBAAA;IACA,cAAA;IACA,YAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;EAvRJ;EA2RA;IACE,cAAA;EAzRF;EA0RE;IACE,WAAA;IAEA,yBAAA;IACA,WAAA;EAzRJ;EA8RE;IACE,aAAA;EA5RJ;EA+RE;IACE,aAAA;EA7RJ;EAiSA;IACE,YAAA;IAIA,yBAAA;IACA,eAAA;IACA,aAAA;IACA,WAAA;IACA,iEAAA;IACA,UAAA;IACA,gBAAA;IACA,QAAA;EAlSF;EAmSE;IACE,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;EAjSJ;EAoSE;IACE,YAAA;IACA,qBAAA;IAEA,mBAAA;IACA,2CAAA;EAnSJ;EAsSM;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,SAAA;IACA,WAAA;EApSR;EAwSI;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;EAtSN;EAySI;IACE,uBAAA;IACA,cAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,sBAAA;IACA,cAAA;IACA,YAAA;IACA,mBAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;EAvSN;EA2SE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,SAAA;IAEA,cAAA;EA1SJ;EA4SI;IAGE,SAAA;IACA,uBAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,aAAA;IACA,8BAAA;IACA,6BAAA;EA5SN;EA8SI;IACE,kBAAA;EA5SN;EA6SM;IACE,WAAA;IACA,qBAAA;IACA,sBAAA;IACA,WAAA;IACA,YAAA;IACA,0DAAA;IACA,wBAAA;EA3SR;EA8SI;IACE,eAAA;IACA,MAAA;IACA,UAAA;IACA,mBAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;IACA,gBAAA;EA5SN;EA6SM;IACE,uBAAA;IACA,kBAAA;IACA,UAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;EA3SR;EA4SQ;IACE,cAAA;IACA,eAAA;IACA,gBAAA;IACA,yBAAA;IACA,iBAAA;EA1SV;EA4SQ;IACE,uBAAA;IACA,yBAAA;IACA,gCAAA;IACA,SAAA;EA1SV;EA8SU;IACI,WAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;EA5Sd;EA8SU;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,cAAA;EA5SZ;EA8SU;IAEE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,cAAA;EA7SZ;EAgTQ;IACE,mBAAA;IACA,oBAAA;EA9SV;EAgTQ;IACE,kBAAA;IACA,mBAAA;EA9SV;EA+SU;IACE,WAAA;IACA,gBAAA;IACA,YAAA;IACA,cAAA;EA7SZ;EA+SU;IACE,0BAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;IACA,mBAAA;EA7SZ;EAiTM;IACE,SAAA;IACA,aAAA;IACA,UAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,eAAA;EA/SR;EAgTQ;IACE,iBAAA;IACA,cAAA;IACA,YAAA;IACA,kBAAA;EA9SV;EAkTQ;IACE,oBAAA;EAhTV;EAoTI;IACE,uBAAA;IACA,YAAA;EAlTN;EAoTI;IACE,SAAA;EAlTN;EAqTE;IACE,SAAA;IACA,yBAAA;IACA,yBAAA;IACA,aAAA;IACA,mBAAA;EAnTJ;EAqTE;IACE,UAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;IAGA,SAAA;IACA,YAAA;IACA,8BAAA;IACA,gBAAA;IACA,gBAAA;EArTJ;EAwTE;IACE,YAAA;IACA,iBAAA;EAtTJ;EAyTE;IACE,WAAA;IACA,aAAA;IACA,YAAA;IACA,mBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;IACA,eAAA;IACA,YAAA;EAvTJ;EA2TE;IACE,YAAA;IACA,uBAAA;IACA,iBAAA;IACA,YAAA;IACA,cAAA;IACA,iBAAA;EAzTJ;EA0TI;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAxTN;EAyTM;IAEE,cAAA;EAxTR;EA2TI;IACE,qBAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,kBAAA;IACA,sBAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IAEA,eAAA;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,cAAA;EA1TR;EA4TM;IAGE,WAAA;EA5TR;EAkUI;IACE,iBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;IACA,sBAAA;EAhUN;EAkUI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;EAhUN;EAuUM;IACE,cAAA;EArUR;EAuUM;IACE,cAAA;EArUR;AACF;AA0UA;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EAEA,gDAAA;AA1UF;AA2UE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EAEA,QAAA;AA1UJ;AA4UI;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EAEA,SAAA;AA3UN;AA4UM;EAEE,4BAAA;AA3UR;AA6UM;EACE,YAAA;AA3UR;AA6UM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AA3UR;AA6UM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AA3UR;AA8UI;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;EACA,YAAA;AA5UN;AA6UM;EACE,YAAA;EACA,aAAA;AA3UR;AA+UM;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AA7UR;AA8UQ;EACA,gBAAA;AA5UR;AA+UM;EACE,SAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AA7UR;AA8UQ;EAEI,aAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AA7UZ;;AAqVA;EACE,mBAAA;AAlVF;;AAqVA;EACE,mBAAA;AAlVF","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n$import-theme-font: Roboto;\n\n@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');\n\n$base-font: 'Roboto', sans-serif;\n$heading-font: 'Roboto', sans-serif;\n\n/*** Color Variables *****/\n$dark: #13192d;\n$light: #f9f9f9;\n$light-gray: #eff4f5;\n$white: #fff;\n$black: #000000;\n$primary: #4cb8ac;\n$light-primary: #dff7f9;\n$clight-primary: #e3fbf8;\n$xlight-primary: #f5fbfc;\n$primary-hover: #4cb8ac;\n$secondary: #4179bd;\n$secondary-hover: #3a6daa;\n$placeholder-color: #b7b9c1;\n$alert: #d0031c;\n$pending: #ff7a0a;\n$close: #1f60c3;\n$red: #d0031c;\n$success-green: #52c41a;\n$blue: #0053af;\n$light-blue: #f2fffe;\n$error:#ff4d4f;\n$primary-ghost: #e4f8f9;\n\n$top-nav-color: none;\n$dark-text-clr: #13171f;\n$gray-text-clr: #656c78;\n$gray-text-clr-1: #616b7d;\n$mgray-text-clr: #7e828c;\n$mgray-text-clr-1: #7d8494;\n$lgray-text-clr: #acb2be;\n// $footer-bg: #2f3b3d;\n$footer-bg: #0c1a38;\n$footer-text-clr: rgba(255, 255, 255, 0.59);\n\n$left-nav-clr: #12161f;\n$left-nav-icon: #515b72;\n\n$input-bg: #fcfcfc;\n$input-b-clr: #e8e8e8;\n$input-br-clr: #ccd8db;\n$input-lbl-clr: #566074;\n$checkbox-txt-clr: #5f636c;\n\n$modal-h-clr: #3b414d;\n$detail-bg: #fcfbfb;\n\n$google: #db4437;\n$facebook: #3b5998;\n\n$mail-clr: #4cb8ac;\n$fb-clr: #475993;\n$twt-clr: #03a9f4;\n$in-clr: #0077b7;\n\n$forsale-bg: #dff7f9;\n$forsale-clr: #4cb8ac;\n$salepending-bg: #fff2dc;\n$salepending-clr: #f5a623;\n$contingent-bg: #f1e7ff;\n$contingent-clr: #bb8eff;\n$sold-bg: #ffebee;\n$sold-clr: #eb6777;\n$withdrawn-bg: #fff0e2;\n$withdrawn-clr: #b78151;\n$inreview-bg: #E2EFFF;\n$inreview-clr: #4A90E2;\n$for-rent-bg: #e2efff;\n$for-rent-clr: #4a90e2;\n$offer-pending-clr: #efa92b;\n$offer-pending-bg: #fdf8ed;\n$offer-accepted-clr: #4cb8ac;\n$offer-accepted-bg: #edf7f6;\n\n$primary-color: #3a7ca5;\n$secondary-color: #4cb8ac;\n$background-color: #f4f4f8;\n$text-color: #333;\n$border-color: #e0e0e0;\n$disable-color: #a0a0a0;\n\n$primary-teal: #4CB8AC;\n$primary-teal-hover: #3da396;\n$text-white: white;\n$font-family: 'Roboto', sans-serif;\n$dark-bg: #12161F;\n\n$line-through-text-clr: #71747E;","\n@use 'variables.scss' as *;\n \n.mobile-signup {\n  display: none;\n}\n\n.mobile-menu-icon {\n  display: none;\n} \n\n.full-logo {\n  width: auto;\n  height: 60px;\n  float: left;\n  margin: 0px 18px 0px 0px;\n  position: relative;   \n   display: flex;\n  align-items: center;  \n  &:before {\n    content:none;\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    bottom: 0px;\n    left: 0px; \n    background: #4cb8ac;\n    opacity: 0;\n  }\n  img {\n    max-width: 100%;\n    width: 109px;\n    // padding: 14px 0px 18px;\n    display: block;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: none;\n    }\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: none;\n  } \n  .rev-Brand-img {\n    \n    display: block;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: none;\n    }\n  }\n\n  .dark-Brand-img {\n    display: none;\n\n    &:focus {\n      outline: none;\n      box-shadow: none;\n    }\n  }\n} \n.header-top {\n  background: $top-nav-color;\n  position: fixed;\n  width: 100%;\n  z-index: 1000;\n  top: 0;\n  border-bottom: solid 1px rgba(255, 255, 255, 0.13);\n  height: 61px;\n  padding: 0px 20px 0px 20px;\n  line-height: 61px;\n  z-index: 1000;\n   \n  .nav-top {\n    background: $top-nav-color;\n    line-height: 60px;\n    border: none;\n\n    li {\n      color: $white;\n      font-size: 14px;\n      font-weight: 500;\n      border: none;\n      vertical-align: middle;\n      line-height: 60px;\n      position: relative;\n      top: auto;\n      margin:0;\n      padding:0;\n      &:after{\n        content:none;\n      }\n      &:first-child{\n        a{ \n        padding:0 19px 0 18px;\n        }\n      }\n      &:nth-child(2){\n        a{ \n        padding:0 13.5px 0 18px;\n        }\n      }\n      a {\n        display: block;\n        line-height: 60px;\n        position: relative;\n        color: $white;\n        font-size: 14px;\n        padding:0 18.5px;\n        &:before {\n          content: '';\n          position: absolute;\n          height: 2px;\n          width: 100%;\n          bottom: 1px;\n          left: 0px;\n          background: #4cb8ac;\n          opacity: 0;\n          top: auto;\n        }\n      }\n      &:hover  { \n        &:after {\n          border-bottom: none;  \n        }  \n        color: #ccc; \n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        } \n      }\n\n      &:focus {\n        color: #ccc;\n        outline: none;\n        box-shadow: none;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n\n      &:active {\n        color: #ccc;\n        background: transparent;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n    }\n   \n    li.ant-menu-item.ant-menu-item-selected {\n      background: transparent !important;\n      color: $white !important;\n      outline: none;\n      box-shadow: none;\n      border-bottom-color: $white;\n      \n      a {\n        &:before {\n          opacity: 1;\n        }\n      }\n\n      &:focus {\n        background: transparent !important;\n        color: $primary !important;\n        outline: none;\n        box-shadow: none;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n\n      &:active {\n        background: transparent !important;\n        color: $primary !important;\n        outline: none;\n        box-shadow: none;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n    }\n  }\n\n  .nav-top-right {\n    border: none;\n    background: transparent;\n    line-height: 60px;\n    height: 60px;\n    display: block;\n\n    li {\n      position: relative;\n      vertical-align: middle;\n      border: none;\n      top: 0px;\n      margin: 0 8.5px;\n      padding: 0px;\n      line-height: 60px;\n      &:first-child{\n        // padding-right:10px;\n      }\n      a {\n        font-size: 14px;\n        font-weight: 500;\n        color: $white;\n        display: block;\n        line-height: 60px;\n        position: relative;\n        text-transform: none;\n        letter-spacing: 0px;\n        text-transform: uppercase;\n        svg {\n          line-height: 60px;\n          display: block;\n          fill: $primary;\n          height: 60px;\n        }\n\n        &:before {\n          content: '';\n          position: absolute;\n          height: 2px;\n          width: 100%;\n          bottom: 0px;\n          left: 0px;\n          // background: $white;\n          // background: #13192d;\n          background: #4cb8ac;\n          opacity: 0;\n          top: auto;\n        }\n      }\n      &:hover  { \n        &:after {\n          border-bottom: none;  \n        }\n        color: #ccc;\n\n        a {\n          &:before {\n            opacity: 1;\n            background-color: transparent;\n          }\n          &:hover {\n            &:before { \n              background-color: transparent;\n            }\n          }\n        }\n       \n      }\n\n      &:focus {\n        color: #ccc;\n        outline: none;\n        box-shadow: none;\n\n        a {\n          &:before {\n            opacity: 1;\n            background-color: transparent;\n          }\n        }\n          \n      }\n\n      &:active {\n        color: #ccc;\n        background: transparent;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n      .ant-btn {\n        span {\n          line-height: normal;\n        }\n      }\n    }\n    li.notification{\n      display:none;\n    }\n\n    li.ant-menu-item.ant-menu-item-selected {\n      background: transparent !important;\n      color: $white !important;\n      outline: none;\n      box-shadow: none;\n      border-bottom-color: $white;\n\n      a {\n        &:before {\n          opacity: 1;\n        }\n      }\n\n      &:focus {\n        background: transparent !important;\n        color: $primary !important;\n        outline: none;\n        box-shadow: none;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n\n      &:active {\n        background: transparent !important;\n        color: $primary !important;\n        outline: none;\n        box-shadow: none;\n\n        a {\n          &:before {\n            opacity: 1;\n          }\n        }\n      }\n    }\n\n    li:last-child {\n      margin-right:0;\n      margin-left:12px;\n      &:hover {\n        border-color: transparent;\n      } \n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n\n      &:active {\n        border-color: transparent;\n      }\n\n      &:last-child::before {\n        height: 24px;\n        width: 1px;\n        position: absolute;\n        left: 6px;\n        top: 17px;\n        background: #d8d8d8;\n        // background: #E5E5E5;\n        content: '';\n      }\n    }\n\n    .ant-btn {\n      font-weight: 500;\n      font-size: 14px;\n      color: $dark-text-clr;\n      line-height: 34px;\n      margin: 10px 0px;\n      padding-bottom: 0;\n      padding-top: 0; \n      height: 34px;\n      span {\n        line-height: 30px;\n      }\n\n      &:hover {\n        color: $primary;\n        border-color: $primary;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n\n      &:active {\n        border-color: $primary;\n      }\n    }\n\n    li {\n      button.ant-btn {\n        color: $white;\n        border-color: $white;\n        // letter-spacing: 1px;\n        letter-spacing: 0;\n        text-transform: uppercase;\n        &:hover {\n          color: $primary;\n          border-color: $primary;\n        }\n\n        &:focus {\n          color: $primary;\n          border-color: $primary;\n        }\n\n        &:active {\n          color: $primary;\n          border-color: $primary;\n        }\n      }\n    }\n\n    li {\n      .top-nav-dropdown {\n        min-width: 176px;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        text-align: right;\n        \n        .ant-dropdown-link {\n          color: $white;\n          font-size: 16px;\n\n          i {\n            color: $primary;\n            font-size: 16px;\n          }\n        }\n\n        .account-icon {\n          display: inline-block;\n          width: 32px;\n          height: 32px;\n          border: solid 1px #e5e5e5;\n          border-radius: 50%;\n          vertical-align: middle;\n          text-align: center;\n          margin-right: 14px;\n          background: $white;\n          margin-top: 0px;\n          font-size: 12px;\n          font-weight: 500;\n          line-height: 32px;\n          color: #13171f; \n          span {\n            font-size: 12px;\n            color: $primary;\n            display: block;\n            line-height: 32px;\n            font-weight: 500;\n          }\n        }\n        span.username {\n          display: inline-block;\n          margin-right: 8px;\n          width: 150px;\n          text-align: left;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          vertical-align: middle; \n          text-transform: none;\n          font-size:16px;\n          letter-spacing: 0;\n        }\n        .user-icon {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          margin: 0px;\n          display: block;\n        }\n\n        i {\n          color: $primary;\n          font-size: 16px;\n        }\n      }\n    }\n  }\n} \n.header-top-colored{\n// background-color: #EDF7F6;\n// border-bottom: solid 1px #EFEFEF;\nbackground-color: #d3e2e1;\nborder-bottom: solid 1px #c9dad9;\n.rev-Brand-img{\n  display:none;\n}\n.dark-Brand-img{\n  display:block;\n}\n .nav-top{\n  li{\n      // color: #13171f;\n      color:#1f2124;\n    a{\n      // color: #13171f;\n      color:#1f2124;\n      &:hover{\n        &:before { \n          // background:#1f2124; \n              background: #4cb8ac;\n\n        }\n      }\n    }\n    }\n }\n \n  .nav-top-right {\n    li {\n      // color: #13171f; \n    color: #3b414d;\n      a{\n      // color: #13171f; \n      color: #3b414d;\n        &:hover {\n            &:before {\n              background: #13171f;\n            }\n          }\n        &:before{\n        background: #13171f;\n        }\n      }\n        button.ant-btn {\n          // color: #13171f;\n          //   border-color: #13171f;\n          color: #4CB8AC;\n          border-color: #4CB8AC; \n          &:hover{\n            color: #13171f;\n            border-color: #13171f; \n          }\n        }\n      }\n\n  }\n }\n.ant-dropdown-menu {\n  border-radius: 0px 0px 4px 4px;\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n  padding: 0px;\n  margin: 0px;\n  list-style: none;\n  width: 213px;\n  max-width: 213px;\n  // right: -15px;\n  right: 0px;\n\n  li {\n    border-top: 1px solid #efefef;\n    padding: 0px;\n    background-color: $white; \n    a {\n      color: $primary;\n      font-weight: 500;\n      font-size: 16px;\n      display: block;\n      text-align: center;\n      padding: 15px 12px;\n      margin: 0px;\n      line-height: 20px;\n\n      &:active {\n        color: $primary;\n      }\n\n      &:focus {\n        color: $primary;\n      }\n\n      &:active {\n        color: $primary;\n      }\n    }\n  }\n\n  li:first-child {\n    border-top: none;\n  }\n  li.ant-dropdown-menu-item { \n    width:100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    &:hover {\n      background-color: #e6f7ff;\n      outline: none;\n    }\n  }\n  li.ant-dropdown-menu-item-selected {\n    background-color: #e6f7ff;\n    outline: none;\n    a {\n      background: transparent !important;\n      color: $primary !important;\n      outline: none;\n    }\n  }\n}\n\n.full-logo.active {\n  &:before {\n    opacity: 1;\n  }\n}\n\n.header-top.nav-active {\n  .full-logo.active {\n    &:before {\n      background: $dark;\n      opacity: 1;\n    }\n  }\n}\n\n.header-top.nav-active {\n  background: $white;\n  border-bottom: solid 1px #efefef;\n\n  .nav-top {\n    li {\n      color: $dark;\n\n      a {\n        color: $dark;\n\n        &:before {\n          background: $dark;\n        }\n      }\n\n      &:hover {\n        color: $dark;\n\n        a {\n          color: $dark;\n\n          &:before {\n            background: $dark;\n          }\n        }\n      }\n\n      &:focus {\n        color: $dark;\n\n        a {\n          color: $dark;\n\n          &:before {\n            background: $dark;\n          }\n        }\n      }\n\n      &:active {\n        color: $dark;\n\n        a {\n          color: $dark;\n\n          &:before {\n            background: $dark;\n          }\n        }\n      }\n    }\n  }\n\n  .nav-top-right { \n    li {\n      button.ant-btn {\n        color: $primary;\n        border-color: $primary;\n\n        &:hover {\n          color: $dark-text-clr;\n          border-color: $dark-text-clr;\n        }\n\n        &:focus {\n          color: $dark-text-clr;\n          border-color: $dark-text-clr;\n        }\n\n        &:active {\n          color: $dark-text-clr;\n          border-color: $dark-text-clr;\n        }\n      } \n      a { \n        color: $dark-text-clr;\n        &:before {\n          //background: $dark-text-clr;\n          background: transparent;\n        }\n      }\n\n      &:hover {\n        a {\n          &:before {\n            //background: $dark-text-clr;\n            background: transparent;\n          }\n        }\n      } \n      &:first-child::before {\n        background: $dark;\n      } \n      &:last-child {\n        margin-right: 0px; \n        padding-right: 0px;\n\n        &:hover {\n          border-color: transparent;\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: none;\n        }\n\n        &:active {\n          border-color: transparent;\n        } \n        \n        &:before {\n          content: none;\n          display: none;\n        } \n      }  \n      .top-nav-dropdown {\n        \n        .user-icon {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          margin: 0px;\n          display: block;\n        }\n\n        .ant-dropdown-link {\n          color: $dark-text-clr;\n\n          i {\n            color: $primary;\n          }\n        }\n\n        .account-icon {\n          display: inline-block;\n          width: 32px;\n          height: 32px;\n          border: solid 1px #e5e5e5;\n          border-radius: 50%;\n          vertical-align: middle;\n          text-align: center;\n          margin-right: 8px;\n          background: $white; \n          margin-top: 0px;\n          font-size: 12px;\n          font-weight: 500;\n          line-height: 32px;\n          color: #13171f; \n\n          span {\n            font-size: 12px;\n            color: $primary;\n            display: block;\n            line-height: 32px;\n            font-weight: 500;\n            padding-top: 0;\n            padding-bottom: 0;\n          }\n        }\n\n        i {\n          color: $primary;\n          font-size: 16px;\n        }\n      }\n    }\n\n    li.ant-menu-item-selected{\n      &:last-child {\n        margin-right: 0px;\n\n        &:hover {\n          border-color: transparent;\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: none;\n        }\n\n        &:active {\n          border-color: transparent;\n        }\n      }\n    }\n\n\n    .ant-btn {\n      border-color: $primary;\n      color: $primary;\n\n      &:hover {\n        color: $dark;\n        border-color: $dark;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: none;\n      }\n\n      &:active {\n        border-color: $dark;\n      }\n    }\n    .table-dropdown {\n      a {\n        color: $primary;\n        font-weight: 500;\n        font-size: 16px;\n\n        i {\n          font-size: 20px;\n        }\n\n        &:before {\n          content: none;\n        }\n      }\n    }   \n  } \n\n  .full-logo {\n    .rev-Brand-img {\n      display: none;\n    }\n\n    .dark-Brand-img {\n      display: block;\n    }\n  }\n}\n\n.header-top.nologin {\n  .nav-top-right { \n    li{\n      &:first-child {\n        position: relative; \n        &:before {\n        height: 24px;\n        width: 1px;\n        position: absolute;\n        right: 0px;\n        top: 17px;\n        background: #d8d8d8;\n        content: '';\n        content:none;\n        }\n      }\n      &:last-child { \n        &:before {\n          content: none;\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .container {\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .ant-col-offset-6 {\n    margin-left: 0px !important;\n  }\n\n  section.HomeBanner {\n    padding: 0px 15px;\n  }\n\n  .heading-top {\n    padding: 42px 0px 0px 0px;\n  }\n\n  .second-heading {\n    margin-top: 14px;\n  }\n\n  button.home-btn {\n    margin-bottom: 25px;\n  }\n\n  .what-we-do {\n    text-align: center;\n    padding: 15px 25px 30px 25px;\n  }\n\n  .inner-mls-features {\n    padding: 40px 25px;\n  }\n\n  section.how-it-works {\n    padding: 30px 25px;\n  }\n\n  .questions {\n    padding: 42px 25px;\n  }\n}\n\n@media only screen and (max-width: 1280px) and (min-width: 720px){\n  .header-top{\n    .nav-top-right{\n      li { \n      padding: 0px 17px; \n      }\n    }\n  }\n}\n@media only screen and (max-width: 1265px) and (min-width: 1031px)\n{\n  .header-top{\n    .nav-top{\n      li{\n        margin-left: 10px;\n        margin-right: 10px;\n      }\n    }\n\n    .nav-top-right{\n      li{ \n        padding: 0px 10px;\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 1030px) and (min-width: 481px) {\n  .ant-dropdown-menu {\n    width: 162px;\n    max-width: 162px;\n    right: 0px;\n    top: 15px;\n  }\n  .full-logo {\n    margin: 0;\n    &:before {\n      left: 2px;\n    }\n  }\n\n  .mobile-signup {\n    display: block;\n    button {\n      background: transparent;\n      color: #54baac;\n      border: 1px solid #54baac;\n      font-weight: 500;\n      padding: 5px 11px;\n      width: auto;\n      letter-spacing: normal;\n      display: block;\n      float: right;\n      margin-top: 15px;\n      border-radius: 4px;\n    }\n  }\n\n  .mobile-menu-icon {\n    display: block;\n    img {\n      float: left;\n      // margin: 25px 15px 0px 0px;\n      margin: 27px 12px 0px 0px;\n      width: 22px;\n      filter: invert(1);\n    }\n  }\n\n  .header-top {\n    .nav-top {\n      display: none;\n    }\n\n    .nav-top-right {\n      display: none;\n    }\n  }\n\n  .mobile-menu {\n    height: auto;\n    // height: 100%;\n    // display: block;\n    // background-color: #0c1a38;\n    background-color: #ffffff;\n    position: fixed;\n    z-index: 1004;\n    width: 100%;\n    transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n    opacity: 1;\n\n    img {\n      // margin-top: 16px;\n    }\n\n    .ant-layout-header {\n      height: 60px;\n      padding: 0px 15px;\n      // background: #0c1a38;\n      border: solid 1px rgba(255, 255, 255, 0.13); \n      background: #ffffff;\n      .close {\n        img {\n          position: absolute;\n          top: 23px;\n          margin: 0px;\n          width:14px;\n          height: 14px;\n        }\n      }\n\n      .menu-logo {\n        height: 24px;\n        width: auto;\n        margin-top: 0px;\n        margin-bottom: 8px;\n        margin-left: 8px;\n      }\n\n      button {\n        float: right;\n        margin-top: 10px;\n        background: transparent;\n        color: #54baac;\n        border: 1px solid #54baac;\n        font-weight: 500;\n        padding: 5px 11px;\n        width: auto;\n        letter-spacing: normal;\n        margin-top: 14px;\n        margin-bottom: 0px;\n        margin-right: -25px;\n      }\n    }\n\n    ul {\n      list-style: none;\n      text-align: left;\n      font-size: 24px;\n      font-weight: 500;\n      padding: 0px;\n      margin: 0;\n      // color: #fff;\n      color:#1f2124; \n\n      li {\n        // margin: 40px 0px;\n        // color: $primary;\n        margin:0px; \n        padding:30px 20px 15px;\n        font-size: 16px;\n        line-height: 19.2px; \n        font-weight: 500;\n        display: flex;\n        justify-content: space-between;\n        border-top:1px solid #CCD8DB;  \n      } \n      .dropdown{\n        position: relative;\n        &:after {\n          content: \"\";\n          display: inline-block;\n          vertical-align: middle;\n          width: 18px;\n          height: 18px;\n          background: url('/assets/images/icons/sub-menu-arrow.svg'); \n          background-size: contain;\n        } \n      }\n      .dropdown-item{ \n        position: fixed;\n        top: 0;\n        z-index: 1;\n        padding: 20px 0;\n        height: calc(100vh - 40px);\n      }\n      li:first-child { \n        padding:11px 20px 15px;\n        border:none;\n      }\n      li:last-child {\n        margin:0; \n      }\n    }\n\n    .mob-btn{   \n      margin: 0;\n      background-color: #F5F7F9;\n      text-transform: uppercase;\n      display: flex;\n      flex-direction: row; \n    }\n    \n    button {        \n      width: 50%;\n      height: auto;\n      padding: 13px;\n      background: transparent;\n      color: #1f2124;\n      letter-spacing: 1px;\n      font-weight: 500;\n      // margin-bottom: 24px;\n      // margin-top: 20px;\n      margin:0;\n      border:none;\n      border-left: 1px solid #E5E5E5;\n      border-radius: 0;\n      text-align: left; \n\n    }\n    button:first-child {\n      border:none;\n      text-align: right; \n    }\n\n    .property {\n      width: 100%;\n      padding: 13px;\n      height: auto;\n      background: #4cb8ac;\n      color: #fff;\n      font-weight: bold;\n      letter-spacing: 1px;\n      margin-top: 0px;\n      border: none;\n    }\n  }\n  .mobile-signup {\n    .mobile-dropdown {\n      border: none;\n      background: transparent;\n      line-height: 60px;\n      height: 60px;\n      display: block;\n      text-align: right;\n      li {\n        margin: 0px;\n        border: none;\n        padding: 0px 0px;\n        a {\n          // color: #fff;\n          color: #111111;\n        }\n      }\n      .account-icon {\n        display: inline-block;\n        width: 32px;\n        height: 32px;\n        border: solid 1px #e5e5e5;\n        border-radius: 50%;\n        vertical-align: middle;\n        text-align: center;\n        margin-right: 8px;\n        background: #fff;\n\n        margin-top: 0px;\n          font-size: 12px;\n          font-weight: 500;\n          line-height: 32px;\n          color: #13171f; \n\n        span {\n          // bottom: 0px;\n          // position: absolute;\n          color: #111;\n          // left: 13px;\n          // right: auto;\n          // top: 1px;\n        }\n      }\n      .username{\n        margin-right: 8px;\n        width: 60px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: inline-block;\n        vertical-align: middle;\n      }\n      .user-icon {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        margin: 0px;\n        display: block;\n      }\n    }\n  }\n  .header-top.nav-active {\n    .mobile-dropdown {\n      li {\n        a {\n          color: #111;\n        }\n        i {\n          color: #4cb8ac;\n        }\n      }\n    }\n  }\n\n} \n\n\n@media (max-width: 480px) {\n  .full-logo{ \n    &:before{\n      height:0;\n    }\n    img{\n      max-width:85px;\n      max-height:31.9px;\n    } \n  }\n  .header-top-colored\n  {\n    .mobile-menu-icon\n    {\n      img\n      {\n        filter: invert(1);\n      }\n    }\n    .mobile-signup {\n      .mobile-dropdown {\n        li {\n          a {\n            color: #111111;\n          }\n        }\n      }\n    }\n  }\n  .ant-dropdown-menu {\n    width: 162px;\n    max-width: 162px;\n    right: 0px;\n    top: 15px;\n  }\n  .full-logo {\n    margin: 0;\n    &:before {\n      left: 2px;\n    }\n  }\n\n  .mobile-signup {\n    display: block;\n    button {\n      background: transparent;\n      color: #54baac;\n      border: 1px solid #54baac;\n      font-weight: 500;\n      padding: 0px 20px;\n      width: auto;\n      letter-spacing: normal;\n      display: block;\n      float: right;\n      margin-top: 15px;\n      border-radius: 25px;\n      height:30px;\n    }\n  }\n\n  .mobile-menu-icon {\n    display: block;\n    img {\n      float: left;\n      // margin: 25px 15px 0px 0px;\n      margin: 27px 20px 0px 0px;\n      width: 22px;\n    }\n  }\n\n  .header-top {\n    .nav-top {\n      display: none;\n    }\n\n    .nav-top-right {\n      display: none;\n    }\n  }\n\n  .mobile-menu {\n    height: auto;\n    // height: 100%;\n    // display: block;\n    // background-color: #0c1a38;\n    background-color: #ffffff;\n    position: fixed;\n    z-index: 1004;\n    width: 100%;\n    transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n    opacity: 1;\n    overflow-y: auto;\n    top:0px;\n    img {\n      margin-top: -10px;\n      max-width: 79px;\n      margin-left: 13px;\n      height: 25px;\n    }\n\n    .ant-layout-header {\n      height: 60px;\n      padding: 0px 0 0 20px;\n      // background: #0c1a38;\n      background: #ffffff;\n      border: solid 1px rgba(255, 255, 255, 0.13);\n\n      .close {\n        img {\n          position: absolute;  \n          width: 20px;\n          top:  18px;\n          left:1px;\n          margin: 0px;\n        }\n      }\n\n      .menu-logo {\n        height: 24px;\n        width: auto;\n        margin-top: 0px;\n        margin-bottom: 8px;\n        margin-left: 8px;\n      }\n\n      button { \n        background: transparent;\n        color: #54baac;\n        border: 1px solid #54baac;\n        font-weight: 500;\n        padding: 0px 20px;\n        width: auto;\n        letter-spacing: normal;\n        display: block;\n        float: right;\n        border-radius: 25px;\n        line-height: 16px;\n        margin-top: 14px;\n        margin-right: -24px; \n        height:30px;\n      }\n    }\n\n    ul {\n      list-style: none;\n      text-align: left;\n      font-size: 24px;\n      font-weight: 500;\n      padding: 0px;\n      margin:0;\n      // color: #fff;\n      color:#1f2124; \n\n      li {\n        // margin: 40px 0px;\n        // color: $primary;\n        margin:0;\n        padding:30px 20px 15px;\n        font-size: 16px;\n        line-height: 19.2px; \n        font-weight: 500;\n        display: flex;\n        justify-content: space-between;\n        border-top:1px solid #CCD8DB; \n      } \n      .dropdown{\n        position: relative;\n        &:after {\n          content: \"\";\n          display: inline-block;\n          vertical-align: middle;\n          width: 18px;\n          height: 18px;\n          background: url('/assets/images/icons/sub-menu-arrow.svg'); \n          background-size: contain;\n        } \n      }\n      .dropdown-item{ \n        position: fixed;\n        top: 0;\n        z-index: 1;\n        padding: 0 0 40px 0;\n        height: 100vh;\n        width: 100%;  \n        background-color: #ffffff;\n        overflow-y: auto;\n        .nav-drop-down {         \n          padding: 60px 15px 20px;\n          position: relative;\n          left: auto;\n          flex-direction: column;\n          gap:24px;\n          box-shadow: none;\n          h4{\n            color: #7C8189; \n            font-size: 14px;\n            font-weight: 500;\n            text-transform: uppercase;\n            line-height: 16px; \n          }\n          .learn-dropdown-item{\n            margin: 0px 0px 4px 0px;\n            padding: 0px 0px 29px 0px;\n            border-bottom:1px solid #CCD8DB;        \n            gap: 18px; \n            &:last-child{\n              // border:none;\n            }\n            img{ \n                margin:0px;\n                max-width: unset; \n                height: auto;\n                max-height: 40px;\n            }\n            h2{    \n              font-size: 16px;\n              font-weight: 500;\n              line-height: 20px;\n              color:#3b414d;\n            }\n            p{\n\n              font-size: 14px;\n              font-weight: 300;\n              line-height: 16px;\n              color:#3b414d;\n            }\n          } \n          .learn-dropdown-item.no-border{\n            border-bottom: none;\n            padding-bottom: 10px;     \n          }\n          .learn-dropdown-sec{\n            text-align: center;\n            align-items: center;\n            img{ \n              width: auto;\n              max-width: unset;\n              height: auto;\n              margin:0 auto;\n            }\n            .listbutton {\n              padding: 0px 80px 0px 81px;\n              font-size: 14px;\n              line-height: 48px;\n              width: auto;\n              margin-bottom: 19px;\n            }\n          }\n        }\n        .close-button{  \n          top: 16px;\n          margin-top: 0;\n          left: 15px;\n          opacity: 1;\n          z-index: 9999;\n          pointer-events: all;\n          position: fixed; \n          img{ \n            margin: 0 0 0 3px;\n            width: 11.65px;\n            height: auto;\n            max-width: 11.65px;\n          }\n        }\n        .mob-btn{\n          button{  \n            padding: 24.5px 35px;  \n          }\n        }\n      }\n      li:first-child { \n        padding:11px 20px 15px;\n        border:none;\n      }\n      li:last-child {\n        margin:0; \n      }\n    }\n    .mob-btn{   \n      margin: 0;\n      background-color: #F5F7F9;\n      text-transform: uppercase;\n      display: flex;\n      flex-direction: row; \n    }\n    button {        \n      width: 50%;\n      height: auto;\n      padding: 13px;\n      background: transparent;\n      color: #1f2124;\n      letter-spacing: 1px;\n      font-weight: 500;\n      // margin-bottom: 24px;\n      // margin-top: 20px;\n      margin:0;\n      border:none;\n      border-left: 1px solid #E5E5E5;\n      border-radius: 0;\n      text-align: left; \n\n    }\n    button:first-child {\n      border:none;\n      text-align: right; \n    }\n\n    .property {\n      width: 100%;\n      padding: 13px;\n      height: auto;\n      background: #4cb8ac;\n      color: #fff;\n      font-weight: bold;\n      letter-spacing: 1px;\n      margin-top: 0px;\n      border: none;\n    }\n  }\n  .mobile-signup {\n    .mobile-dropdown {\n      border: none;\n      background: transparent;\n      line-height: 60px;\n      height: 60px;\n      display: block;\n      text-align: right;\n      li {\n        margin: 0px;\n        border: none;\n        padding: 0px 0px;\n        a {\n          // color: #fff;  \n          color:#111111;\n        }\n      }\n      .account-icon {\n        display: inline-block;\n        width: 32px;\n        height: 32px;\n        border: solid 1px #e5e5e5;\n        border-radius: 50%;\n        vertical-align: middle;\n        text-align: center;\n        margin-right: 8px;\n        background: #fff;\n\n        margin-top: 0px;\n          font-size: 12px;\n          font-weight: 500;\n          line-height: 32px;\n          color: #13171f; \n\n        span {\n          // bottom: 0px;\n          // position: absolute;\n          color: #111;\n          // left: 13px;\n          // right: auto;\n          // top: 1px;\n        }\n      }\n      .username{\n        margin-right: 8px;\n        width: 60px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: inline-block;\n        vertical-align: middle;\n      }\n      .user-icon {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        margin: 0px;\n        display: block;\n      }\n    }\n  }\n  .header-top.nav-active {\n    .mobile-dropdown {\n      li {\n        a {\n          color: #111111; \n        }\n        i {\n          color: #4cb8ac;\n        }\n      }\n    }\n  }\n}\n.nav-drop-down {\n  position: absolute;\n  left: 0; \n  z-index:222;\n  // min-width: 760px; \n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 500;\n  color: #212529;\n  background-color: #fff;\n  border:none;\n  justify-content:center; \n  border-radius: 4px;\n  display: flex;\n  flex-direction:row; \n  gap:40px;\n  padding: 24px;\n  // box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.16);\n  box-shadow: 0px 2px 10px 0px rgba(0,0,0,.19);\n  .col-section{ \n    flex: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    // min-width: 332.2px;\n    gap:0px;\n    // min-width: 255.5px;\n    .learn-dropdown-item{\n      color: #13171F; \n      height: auto; \n      padding:18px;\n      width: 100%; \n      border:none; \n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: flex-start;\n      min-width: 340px;\n      // gap:23.82px;\n      gap:20px;\n      &:hover{\n        // background: rgb(248, 248, 248);\n        background: transparent none;\n      }\n      .text{\n        flex-grow: 1;\n      }\n      h2{\n        font-size: 16px;\n        line-height: 20px; \n        font-weight: 500;\n        margin:0 0 2px 0;\n        padding:0;\n        color:#3B414D;\n      }\n      p{\n        font-size: 14px;\n        line-height: 19px; \n        font-weight: 300;\n        margin:0;\n        padding:0;\n        color:#3B414D;\n      }\n    }\n    .learn-dropdown-sec{\n      color: #13171F;  \n      height: auto;\n      padding:0 16px 0 0;\n      width: 100%; \n      border:none; \n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: flex-start;\n      gap:20px;\n      cursor: auto;\n      img{\n        width:198px;\n        height: 179px;        \n        // width:150px;\n        // height:135.59px;\n      }\n      h2{\n        font-size: 28px;\n        line-height: 32.81px; \n        font-weight: 400;\n        margin:0 0 4px 0;\n        padding:0;\n        color: #13171F;\n        strong{ \n        font-weight: 700;\n        }\n      } \n      .listbutton{ \n        margin: 0;\n        position: relative;\n        padding: 14.8px 79px 14.8px 79.2px;\n        border-radius: 50px;\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 16.41px; \n        letter-spacing: 1px;\n        text-align:center;\n        height: auto;\n        background-color: #4cb8ac;\n        border:1px solid #4cb8ac;\n        color: #ffffff;\n        &:focus,\n          &:hover{\n            outline: none;\n            height: auto;\n            background-color: #ffffff;\n            border-color: #4cb8ac;\n            color: #4cb8ac;\n        }\n      }\n    }\n  }\n}\n\n\n.nav-drop-down.research-drop-down{\n  margin-left: -150px;\n}\n\n.nav-drop-down.whyfalaya-drop-down{\n  margin-left: -175px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
